module.exports = __webpack_public_path__ + "static/GPmain5-f7ea22604990f9934c7ca5c17e32f4be.png";